import { styled } from "@mui/material/styles";
const ChatMain = styled("div")(({ theme }) => ({
  marginTop: "20px",
  width: "90%",
  margin: "0 auto",
  [theme.breakpoints.down("lg")]: {
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    marginTop: "10px",
  },
}));

const MessageContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginBottom: "10px",
  overflowX: "hidden",
  padding: "20px",
  position: "relative",
  "& span.no_message_text": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  [theme.breakpoints.down("lg")]: {
    padding: "0px",
  },
}));

export { ChatMain, MessageContainer };
